
import('./pb23-search--header.css');
import { initLazyLoad, callPinterestAPI } from "@api/utils_2020";

const pb23SearchHeader = {
    init: function () {
        $('body').off('click', '.pb23-search--header--filters .jsToggleFilter').on('click', '.pb23-search--header--filters .jsToggleFilter', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var buttonElement = $(this);
            var submenuElement = buttonElement.parents('.jsFilter').find('.jsToggleable');

            if (submenuElement.is(':visible')) {
                submenuElement.hide();
            } else {
                $('.jsToggleable').hide();
                submenuElement.show();
            }

            return false;
        });

        $('body').on('change', '.pb23-search--header--filters .jsFilter input[type="radio"]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var inputElement = $(this);
            var filterElement = inputElement.parents('.jsFilter');
            var inputName = inputElement.attr('name');
            var target;

            switch (inputName) {
                case 'limit':
                    var currentSort = $('.pb23-search--header--filters .jsFilter input[type="radio"][name="sort"]:checked').val();
                    var sortQuery = `&sort=${currentSort}`;

                    target = `${filterElement.data('href')}&${inputName}=${inputElement.val()}${sortQuery}`;
                    break;

                case 'sort':
                    var currentLimit = $('.pb23-search--header--filters .jsFilter input[type="radio"][name="limit"]:checked').val();
                    var limitQuery = `&limit=${currentLimit}`;

                    target = `${filterElement.data('href')}&${inputName}=${inputElement.val()}${limitQuery}`;
                    break;
            }

            window.location.href = target;

            return false;
        });

        
        $(".pb23-search--header .jsClearSearch").on("click", function (e) {
            e.preventDefault();
            $('.pb23-search--header .jsSearchInput').val('');
            return false;
        });

    }
}

// initialize component
window.loadedComponents.push({ component: 'pb23-search--header', init: pb23SearchHeader.init });

export default () => {
    pb23SearchHeader.init();
}